module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-breadcrumbs', {
    staticClass: "pl-4",
    attrs: {
      "icons": "",
      "divider": "chevron_right"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('v-breadcrumbs-item', {
      key: item.id,
      attrs: {
        "to": item.to,
        "exact": true
      }
    }, [_vm._v("\n        " + _vm._s(item.text) + "\n    ")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35368c1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainBreadcrumb.vue
// module id = 337
// module chunks = 2